import { Text, Icon } from '@components/primitives';
import colors from '@theme/colors';
import React from 'react';

export function getDisabledColorForText(isDisabled: boolean): string {
  return isDisabled ? colors.neutral.darkMist : colors.neutral.charcoal;
}

export function getBorderColorForInput(sError: string | undefined, isFocused: boolean): string {
  let borderResult = colors.disabled.smoke;
  if (sError && sError.length > 0 && isFocused) {
    borderResult = colors.error.rose;
  } else if (isFocused) {
    borderResult = colors.secondary.orchid;
  }
  return borderResult;
}

export function shouldShowError(sErrorMsg: string | undefined): React.JSX.Element | null {
  if (sErrorMsg && sErrorMsg.length > 0) {
    return (
      <Text
        testID="txtLoginPhoneError"
        variant="sm-normal"
        marginTop="4px"
        alignSelf="stretch"
        color={colors.error.rose}
        textAlign="left">
        {sErrorMsg}
      </Text>
    );
  }
  return null;
}

export function shouldShowCloseIcon(
  phoneNumber: string,
  setPhoneNumber: (val: string) => void,
): React.JSX.Element | null {
  if (phoneNumber && phoneNumber.length > 0) {
    return (
      <Icon
        testID="btnClearTxtFld"
        sentry-label="btnClearTxtFld"
        size={24}
        name="close-circle"
        family="antdesign"
        color={colors.neutral.charcoal}
        marginRight="16px"
        onPress={() => setPhoneNumber('')}
      />
    );
  }
  return null;
}

export function shouldGetCloseIcon(
  isDisabled: boolean,
  phoneNumber: string,
  setPhoneNumber: (val: string) => void,
): React.JSX.Element | null {
  return !isDisabled ? shouldShowCloseIcon(phoneNumber, setPhoneNumber) : null;
}

export function getBackgroundColor(isDisabled: boolean): string {
  return isDisabled ? colors.disabled.smoke : colors.neutral.cotton;
}
